import React from "react";
import PropTypes from "prop-types";

const MediaFeatureRow = ({ fields }) => {
  const {
    title = "",
    description = "",
    imageUrl = "",
    videoUrl = "",
    showBorder = false,
  } = fields || {};

  return (
    <div
      className={`w-full ${
        showBorder ? "pt-[80px]" : ""
      } pb-[50px] md:px-[calc((100%-980px)/2)] bg-black font-[HelveticaRoman,Helvetica,sans-serif]`}
    >
      <div className="grid grid-cols-1 md:grid-cols-[40%_60%] gap-10 px-5 items-center">
        {/* LEFT: MEDIA */}
        <div className="w-full">
          {videoUrl ? (
            <div className="w-full aspect-video bg-black overflow-hidden">
              <iframe
                className="w-full h-full"
                src={
                  videoUrl?.includes("watch?v=")
                    ? videoUrl.replace("watch?v=", "embed/") + "?rel=0"
                    : videoUrl
                }
                title={title || "video"}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          ) : (
            <img
              src={imageUrl}
              alt={title || "image"}
              className="h-auto object-cover"
            />
          )}
        </div>

        {/* RIGHT: CONTENT */}
        <div className="text-white text-center md:text-left">
          <h2 className={`${showBorder ? "text-[35px] leading-none mb-5 font-normal" : "text-[28px] leading-none mb-5 font-normal"}`}>
            {title}
          </h2>

          <p className="text-[16px] text-white">
            {description}
          </p>
        </div>
      </div>

      {showBorder && (
        <hr className="w-full border-t border-white mt-[50px] mb-[20px]" />
      )}
    </div>
  );
};

/* =========================
   PROP TYPES
========================= */

MediaFeatureRow.propTypes = {
  fields: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    imageUrl: PropTypes.string,
    videoUrl: PropTypes.string,
    showBorder: PropTypes.bool,
  }),
};

/* =========================
   DEFAULT PROPS
========================= */

MediaFeatureRow.defaultProps = {
  fields: {
    title: "",
    description: "",
    imageUrl: "",
    videoUrl: "",
    showBorder: false,
  },
};

export default MediaFeatureRow;